export const VNMENU_SET_MENU = 'VNMENU_SET_MENU'
export const VNMENU_SET_AGE_CONFIRMED = 'VNMENU_SET_AGE_CONFIRMED'
export const VNMENU_ADD_CART_ITEMS = 'VNMENU_ADD_CART_ITEMS'
export const VNMENU_SET_CART_MENU_ID = 'VNMENU_SET_CART_MENU_ID'
export const VNMENU_CART_RESET = 'VNMENU_CART_RESET'
export const VNMENU_SET_EXPERIENCE_EVENT_FILTER = 'VNMENU_SET_EXPERIENCE_EVENT_FILTER'
export const VNMENU_SET_ITEM_SEARCH_TEXT = 'VNMENU_SET_ITEM_SEARCH_TEXT'
export const VNMENU_SET_CROSS_VENUE_MENU = 'VNMENU_SET_CROSS_VENUE_MENU'
